// About Us Page Data

export const aboutHeroData = {
  tagline: "SOBRE NOSOTROS",
  title: "De Leire a Asisant: evolución hacia el futuro del comercio cloud",
  subtitle: "Una historia de innovación, crecimiento y especialización en el ecosistema de servicios tecnológicos."
};

export const aboutStatsData = [
  { number: "2019", label: "Fundación de Leire" },
  { number: "25+", label: "Empresas confían en nosotros" },
  { number: "4", label: "Mercados activos" },
  { number: "2026", label: "Nace Asisant" }
];

export const storyData = {
  title: "Nuestra historia",
  paragraphs: [
    "Todo comenzó en 2019 con la fundación de Leire, una empresa con la visión de transformar la manera en que los distribuidores IT y proveedores de servicios tecnológicos gestionaban sus operaciones. Desde el inicio, nuestro foco ha sido claro: Resellers, Marketplaces personalizados, Portales de provisionamiento empresariales internos e integradores de sistemas.",
    "Durante estos años, Leire creció y se especializó, desarrollando soluciones a medida para canales de distribución IT. Hace 3 años dimos un paso estratégico al incorporarnos al mundo de integradores de Telco, ampliando nuestro alcance a operadores de telecomunicaciones que buscaban digitalizar sus servicios cloud.",
    "Actualmente operamos en 4 mercados activos: Chile, Portugal, Costa Rica y Colombia, atendiendo a más de 25 empresas que confían en nuestra tecnología para gestionar sus operaciones de suscripción y marketplace.",
    "A inicios de 2026, tomamos una decisión estratégica: separar las líneas de negocio para ofrecer un enfoque más especializado. Así nace Asisant, una plataforma dedicada exclusivamente al comercio cloud para distribuidores IT, MSPs y Telcos, heredando toda la experiencia y tecnología de Leire."
  ]
};

export const timelineData = [
  {
    year: "2019",
    title: "Fundación de Leire",
    description: "Nace Leire enfocada en Resellers, Marketplaces personalizados y Portales de provisionamiento empresariales para integradores."
  },
  {
    year: "2020",
    title: "Consolidación en Chile",
    description: "Primeros clientes de canal IT en Chile, validando el modelo de negocio con distribuidores locales."
  },
  {
    year: "2021",
    title: "Expansión a Portugal",
    description: "Apertura de operaciones en Portugal, estableciendo presencia en el mercado europeo lusófono."
  },
  {
    year: "2022",
    title: "Entrada al mundo Telco",
    description: "Incorporación al mundo de integradores de Telco, desarrollando módulos especializados para operadores de telecomunicaciones."
  },
  {
    year: "2023",
    title: "Expansión LATAM",
    description: "Apertura de operaciones en Costa Rica y Colombia, consolidando presencia en 4 mercados activos."
  },
  {
    year: "2024",
    title: "Partnerships estratégicos",
    description: "Alianzas con NOS, Telia y otros líderes del sector consolidan la posición de mercado."
  },
  {
    year: "2026",
    title: "Nace Asisant",
    description: "Separación estratégica de líneas de negocio. Asisant emerge como la plataforma especializada en comercio cloud."
  }
];

export const nameOriginData = {
  title: "El nombre Asisant",
  description: "Asisant combina 'asistencia' con 'inteligente', reflejando nuestra esencia: ser el asistente tecnológico que las empresas necesitan para prosperar en la era cloud. No somos solo una plataforma—somos el partner que trabaja contigo para simplificar lo complejo y escalar lo posible."
};

export const missionVisionData = {
  mission: {
    title: "Misión",
    description: "Simplificar y transformar la entrega de servicios de suscripción, permitiendo a distribuidores IT, MSPs y Telcos automatizar operaciones, integrar sin fricciones y expandirse eficientemente."
  },
  vision: {
    title: "Visión",
    description: "Empoderar a cada organización IT en mercados hispanos para prosperar en la economía de suscripción, ofreciendo soluciones que soporten el crecimiento sostenible en un panorama digital dinámico."
  }
};

export const valuesData = [
  {
    id: 1,
    title: "Innovación Continua",
    description: "Invertimos constantemente en I+D para ofrecer soluciones de vanguardia que anticipen las necesidades del mercado.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Orientación al Cliente",
    description: "Cada decisión que tomamos está guiada por el éxito de nuestros clientes. Su crecimiento es nuestro crecimiento.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Excelencia Operativa",
    description: "Nos comprometemos con la precisión, la integración perfecta y la adaptabilidad en todo lo que hacemos.",
    icon: "Target"
  },
  {
    id: 4,
    title: "Integridad",
    description: "Actuamos con transparencia y honestidad, construyendo relaciones de confianza a largo plazo.",
    icon: "Shield"
  }
];

export const teamData = [
  {
    id: 1,
    name: "Director General",
    role: "CEO & Co-fundador",
    description: "Lidera la visión estratégica de Asisant con más de 15 años de experiencia en el sector cloud y tecnológico.",
    image: null
  },
  {
    id: 2,
    name: "Director de Producto",
    role: "CPO & Co-fundador",
    description: "Impulsa la innovación de producto con expertise en automatización cloud y modelos XaaS.",
    image: null
  },
  {
    id: 3,
    name: "Director Técnico",
    role: "CTO",
    description: "Lidera el desarrollo tecnológico aplicando metodologías de vanguardia para impulsar la excelencia.",
    image: null
  },
  {
    id: 4,
    name: "Director Comercial",
    role: "CRO",
    description: "Experto en SaaS con éxito demostrado en construir y liderar empresas de crecimiento.",
    image: null
  }
];

export const partnersLogos = [
  { name: "NOS", logo: "https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/3dvmgdjc_logo-nos.svg" },
  { name: "Telia", logo: "https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/7v6ck0rn_Telia_logo_2022.svg" }
];

export const closingData = {
  text: "Reconociendo las tendencias del mercado y aprovechando años de experiencia y conocimiento del sector, Asisant está redefiniendo cómo se gestionan los servicios de suscripción, permitiendo a las empresas transformar sus operaciones e impulsar un crecimiento sostenible."
};
